/* eslint @typescript-eslint/strict-boolean-expressions: off */

import styles from "./styles/InputCheckbox.module.css";
import cn from "classnames";
import { forwardRef, InputHTMLAttributes, ReactNode, useMemo } from "react";
import { uniqueId } from "lodash";
import { IconCheckmark } from "src/components/ui-components/Icons/IconCheckmark";

interface Props {
  onChange: (event?: any) => void;
  checked: boolean;
  children: ReactNode;
  label?: ReactNode; // This can come with only text, but with an icon as well
  disabled?: boolean;
  hint?: ReactNode; // This can come with only text, but with an icon as well
  className?: string;
}

export const InputCheckbox = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> & Props
>((props, ref) => {
  const {
    label,
    checked,
    hint,
    disabled,
    onChange,
    children,
    className,
    ...nativeProps
  } = props;

  const checkboxId = useMemo(() => uniqueId("checkbox-"), []);

  return (
    <div>
      {label && <label className={styles.label}>{label}</label>}
      <div
        className={cn(styles.checkbox, disabled && styles.disabled, className)}
      >
        <div className={styles.checkmark}>{checked && <IconCheckmark />}</div>
        <input
          id={checkboxId}
          type="checkbox"
          onChange={onChange}
          checked={checked}
          disabled={disabled}
          ref={ref}
          {...nativeProps}
        />

        <label htmlFor={checkboxId}>{children}</label>
      </div>
      {hint && (
        <div className={styles.hint} aria-describedby={checkboxId}>
          {hint}
        </div>
      )}
    </div>
  );
});
